import {
  FETCH_CONDITION_CATS_REQUEST,
  FETCH_CONDITION_CATS_SUCCESS,
  FETCH_CONDITION_CATS_FAILURE,
  SAVE_CONDITION_CAT_REQUEST,
  SAVE_CONDITION_CAT_SUCCESS,
  SAVE_CONDITION_CAT_FAILURE,
  DELETE_CONDITION_CAT_REQUEST,
  DELETE_CONDITION_CAT_SUCCESS,
  DELETE_CONDITION_CAT_FAILURE,
} from './types';

const INITIAL_STATE = {
  conditionCatList: [],
  loading: false,
  error: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_CONDITION_CATS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_CONDITION_CATS_SUCCESS:
      return {
        ...state,
        loading: false,
        conditionCatList: action.payload,
      };

    case FETCH_CONDITION_CATS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload.error,
        conditionCatList: [],
      };
    case SAVE_CONDITION_CAT_REQUEST:
      return {
        ...state,
        error: null,
      };

    case SAVE_CONDITION_CAT_SUCCESS:
      return {
        ...state,
      };

    case SAVE_CONDITION_CAT_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };

    case DELETE_CONDITION_CAT_REQUEST:
      return {
        ...state,
        error: null,
      };

    case DELETE_CONDITION_CAT_SUCCESS:
      return {
        ...state,
      };

    case DELETE_CONDITION_CAT_FAILURE:
      return {
        ...state,
        error: action.payload.error,
      };
    default:
      // ALWAYS have a default case in a reducer
      return state;
  }
};
